import axios from "../../js/project-axios.js";

const isLogin = () => {
    return axios.get("/auth/isLogin", {
        public: true
    });
};

const login = (userOrToken, config) => {
    config = Object.assign({
        public: true
    }, config);
    return axios.post("/auth/login", userOrToken, config);
};

const refreshToken = () => {
    return axios.post("/auth/refreshToken", {
        public: true
    });
};

const register = (user, config) => {
    config = Object.assign({
        public: true
    }, config);
    return axios.post("/auth/register", user, config);
};

const changePassword = (passwords, config) => {
    return axios.post("/auth/changePassword", passwords, config);
};

const resetPassword = (codeAndPassword, config) => {
    config = Object.assign({
        public: true
    }, config);
    return axios.post("/auth/resetPassword", codeAndPassword, config);
};

const getFederatedAccount = (type, code, config) => {
    config = Object.assign({
        params: {
            type,
            code
        }
    }, config || {});
    return axios.get("/auth/getFederatedAccount", config);
};

const sendCode = (type, number, username, config) => {
    config = Object.assign({
        params: {
            type,
            number,
            username
        }
    }, config || {});
    return axios.post("/auth/sendCode", null, config);
};

const bind = (tokenAndCode, config) => {
    return axios.post("/auth/bind", tokenAndCode, config);
};

const unbind = type => {
    return axios.post("/auth/unbind", null, {
        params: {
            type
        }
    });
};

const getRoles = () => {
    return axios.get("/auth/getRoles");
};

export default {
    isLogin,
    login,
    refreshToken,
    register,
    changePassword,
    resetPassword,
    getFederatedAccount,
    sendCode,
    bind,
    unbind,
    getRoles
};